/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Reference to a partner, which is responsible for payment.   (bipro-produktmodell::Beitragszahler)
 */
export interface PaymentContributor {
  /**
   * This is a reference to a partner. The partner must be contained in the list of partners and must have a matching *partnerId*.
   */
  partnerId: string;
}
